const STATUSES = ["new", "confirmed", "delivered", "cancelled"];
const PAY = { paid: "bg-cream text-white", unpaid: "border border-cream/40", refunded: "border border-cream/40 line-through" };

const Detail = ({ label, value }) => (
  <div>
    <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-stone2">{label}</p>
    <p className="mt-1 break-words text-sm">{value || "—"}</p>
  </div>
);

const formatAddress = (s) => {
  if (!s?.line1) return "Shown once the order is paid";
  const cityLine = [s.city, [s.state, s.postal_code].filter(Boolean).join(" ")].filter(Boolean).join(", ");
  return [s.name, s.line1, s.line2, cityLine, s.country].filter(Boolean).join(" · ");
};

export const OrderCard = ({ order, onStatus }) => (
  <article data-testid={`admin-order-${order.id}`} className="border border-cream/20 bg-ink2 p-5 sm:p-6">
    <div className="flex flex-wrap items-start justify-between gap-4">
      <div>
        <h2 className="font-display text-2xl">{order.kaba_name}</h2>
        <p className="mt-1 text-sm">{order.name} · {new Date(order.created_at).toLocaleString()}</p>
      </div>
      <span data-testid={`admin-order-payment-${order.id}`} className={`rounded-full px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] ${PAY[order.payment_status] ?? PAY.unpaid}`}>
        {order.payment_status === "paid" ? "Paid $125" : order.payment_status === "refunded" ? "Refunded" : "Not paid"}
      </span>
    </div>
    <div className="mt-5 grid gap-4 sm:grid-cols-4">
      <Detail label="Email" value={order.email} />
      <Detail label="Phone" value={order.phone} />
      <Detail label="Occasion" value={order.occasion_date} />
      <Detail label="Colour" value={order.colour} />
    </div>
    {order.notes && <div className="mt-4"><Detail label="Notes" value={order.notes} /></div>}
    <div className="mt-4" data-testid={`admin-order-shipping-${order.id}`}>
      <Detail label="Ship to" value={formatAddress(order.shipping)} />
    </div>
    <div className="mt-5 flex flex-wrap gap-2 border-t border-cream/15 pt-4">
      {STATUSES.map((s) => (
        <button key={s} onClick={() => onStatus(order.id, s)} data-testid={`admin-order-${order.id}-status-${s}`} aria-pressed={order.status === s}
          className={`rounded-full border px-4 py-2 font-mono text-[10px] uppercase tracking-[0.2em] transition-colors ${order.status === s ? "border-cream bg-cream text-white" : "border-cream/30 hover:border-cream"}`}>
          {s}
        </button>
      ))}
    </div>
  </article>
);
